import Button from 'components/Button/index'
import Reject from 'components/Images/Reject.png'
import Shortlist from 'components/Images/Shortlist.png'
import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import React from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import SuccessMessage from 'utils/SuccessMessage'
import { getCandidateText } from '../../../../../../../utils/commonFunction'
import { questionarieShortlistReject } from '../../../../../actions'
import { ButtonDiv, ModalText, ShortListModalImg } from '../Style/style'

function CandidateModal({
  onClose,
  actionType,
  setSelectedRowKeys,
  selectedRowKeys,
  summary = false,
  setPageNum,
  roleId,
  questionId,
  status,
  pageNum,
  getIndividualDrawerList,
  fetchCandidateData,
  setViewDrawer,
  setLoading,
  text,
  setTextNew,
  setClear,
  textNew,
  questionaireDBList,
  tab,
  individualDrawerQuestion,
}) {
  const dispatch = useDispatch()
  const params = useParams()

  const handleNoClick = () => {
    if (setTextNew) {
      setTextNew(false)
    }
    if (setClear) {
      setClear(false)
    }
    setSelectedRowKeys([])
    onClose()
  }
  const handleYesClick = async () => {
    if (setTextNew) {
      setTextNew(false)
    }
    if (setClear) {
      setClear(false)
    }
    if (actionType === 'shortlist') {
      dispatch(
        questionarieShortlistReject(params?.jobId, {
          status: 1,
          studentIds: selectedRowKeys,
          ...(text ? { isAllCandidate: true } : {}),
          ...(textNew ? { isAllCandidate: true } : {}),
        })
      )
        .then(response => {
          if (response?.status >= 200 && response?.status < 300) {
            SuccessMessage('Successfully shortlisted the candidates.')
            onClose()
            setSelectedRowKeys([])

            if (summary) {
              if (pageNum == 1) {
                let pageNum = 1
                getIndividualDrawerList({
                  roleId,
                  questionId,
                  status,
                  pageNum,
                  setLoading,
                })
                setViewDrawer(false)
              } else {
                setPageNum(1)
                setViewDrawer(false)
              }
            }
            fetchCandidateData()
            setViewDrawer(false)
          } else {
            ErrorMessage(response?.response?.data?.message)
            onClose()
            setSelectedRowKeys([])
          }
        })
        .catch(error => {
          //
        })
    } else {
      dispatch(
        questionarieShortlistReject(params?.jobId, {
          status: -1,
          studentIds: selectedRowKeys,
          ...(text ? { isAllCandidate: true } : {}),
          ...(textNew ? { isAllCandidate: true } : {}),
        })
      )
        .then(response => {
          if (response?.status >= 200 && response?.status < 300) {
            SuccessMessage('Successfully rejected the candidates.')
            onClose()
            setSelectedRowKeys([])

            if (summary) {
              if (pageNum == 1) {
                let pageNum = 1
                getIndividualDrawerList({
                  roleId,
                  questionId,
                  status,
                  pageNum,
                  setLoading,
                })
                setViewDrawer(false)
              } else {
                setPageNum(1)
                setViewDrawer(false)
              }
            }
            fetchCandidateData()
            setViewDrawer(false)
          } else {
            ErrorMessage(response?.response?.data?.message)
            onClose()
            setSelectedRowKeys([])
          }
        })
        .catch(err => {})
    }
  }

  return (
    <div>
      <ShortListModalImg>
        {actionType === 'shortlist' ? (
          <img src={Shortlist} alt="shortlistImage" />
        ) : (
          <img src={Reject} alt="rejectImage" />
        )}
      </ShortListModalImg>
      <ModalText>
        {tab == 'Candidates' &&
          actionType == 'shortlist' &&
          `Are you sure you want to shortlist ${
            !text ? selectedRowKeys?.length : questionaireDBList?.count
          } ${
            !text
              ? getCandidateText(selectedRowKeys?.length)
              : getCandidateText(questionaireDBList?.count)
          }?`}

        {tab == 'Candidates' &&
          actionType == 'reject' &&
          `Are you sure you want to reject ${
            !text
              ? selectedRowKeys?.length
              : questionaireDBList?.driveCountForFilter
          } ${
            !text
              ? getCandidateText(selectedRowKeys?.length)
              : getCandidateText(questionaireDBList?.driveCountForFilter)
          }?`}

        {tab == 'Summary' &&
          actionType == 'shortlist' &&
          `Are you sure you want to shortlist ${
            !textNew
              ? selectedRowKeys?.length
              : individualDrawerQuestion?.driveCountForFilter
          } ${
            !textNew
              ? getCandidateText(selectedRowKeys?.length)
              : getCandidateText(individualDrawerQuestion?.driveCountForFilter)
          }?`}

        {tab == 'Summary' &&
          actionType == 'reject' &&
          `Are you sure you want to reject ${
            !textNew
              ? selectedRowKeys?.length
              : individualDrawerQuestion?.driveCountForFilter
          } ${
            !textNew
              ? getCandidateText(selectedRowKeys?.length)
              : getCandidateText(individualDrawerQuestion?.driveCountForFilter)
          }?`}
      </ModalText>
      <ButtonDiv>
        <Button.Secondary height={'38px'} text={'No'} onClick={handleNoClick} />
        <Button.Primary height={'38px'} text={'Yes'} onClick={handleYesClick} />
      </ButtonDiv>
    </div>
  )
}
export default CandidateModal
